<template>
  <div class="toolbar">
    <div class="toolbar-start">
      <button @click="del" id="remove">
        <img src="../assets/icons/mdi/delete.svg" />
      </button>
      <button @click="saveWorkflow" id="save">
        <img src="../assets/icons/mdi/content-save.svg" />
      </button>
      <button @click="updateCounter">
        <img src="../assets/icons/mdi/reload.svg" />
      </button>
    </div>
    <div class="toolbar-end">
      <a href="#" @click.prevent="close">
        <icon id="diagram-close" name="remove" scale="1.2" />
      </a>
    </div>
    <b-tooltip target="remove" triggers="hover">Delete Node</b-tooltip>
    <b-tooltip target="save" triggers="hover">Save</b-tooltip>
    <b-tooltip target="diagram-close" triggers="hover">Back Home</b-tooltip>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
// services
import db from '@/services/db'
// helpers
import eventBus from '@/helpers/event-bus'

export default {
  computed: {
    ...mapState('diagramBuilder', [
      'currentNode',
      'nodes',
      'lines',
      'metaData',
      'workflowId',
    ]),
  },
  data() {
    return {
      items: null,
    }
  },
  methods: {
    ...mapMutations('diagramBuilder', ['updateCounter', 'deleteNode']),
    del() {
      /* remove line cascade */
      let that = this

      if (this.currentNode) {
        function removeRelatedLines(id) {
          let arr = []
          that.lines.forEach(line => {
            // connectors have IDs like node.id + 'top'/'left'/...
            if (line.source.includes(id) || id === line.target) {
              arr.push(line.id)
            }
          })

          that.$emit('remove-leader-lines', arr)
        }

        // node-node connections
        removeRelatedLines(this.currentNode.id)

        // node-outcome connections
        if (this.currentNode.hasOwnProperty('outcomes')) {
          this.currentNode.outcomes.forEach(outcome => {
            removeRelatedLines(outcome.id)
          })
        }
        this.deleteNode(this.currentNode.id)
      }
    },
    saveWorkflow() {
      const flowData = {
        metaData: this.metaData,
        nodes: this.nodes,
        edges: this.lines,
      }
      db.workflow.save(this.workflowId, flowData)
    },
    close() {
      eventBus.$emit('showWorkflow', null)
    },
  },
  created() {
    const workflows = this.$store.state.workflows

    if (Object.keys(workflows).length) {
      this.items = workflows
    }

    db.workflow.read(items => {
      this.items = items ? items : null
      if (this.items) {
        Object.keys(this.items).forEach(el => {
          let data

          try {
            data = JSON.parse(this.items[el].data)
          } catch (e) {
            data = []
          }

          this.$store.commit('setWorkflows', {
            id: el,
            data,
            name: this.items[el].name,
          })
        })
      }
    })
  },
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.toolbar {
  background: hsl(235, 71%, 65%);
  display: flex;
  justify-content: space-between;
  height: 3rem;
  border-bottom: 1px solid hsl(0, 0%, 88%);
  div {
    display: flex;
    align-items: center;
    button,
    a {
      border: 1px solid transparent;
      color: hsl(0, 0%, 98%);
      padding: 0.75em;
    }
  }
}
</style>